import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SaeIntegrationsHttpService } from './sae-integrations.http';
import { objectToCamel } from 'ts-case-convert';

@Injectable({
  providedIn: 'root'
})
export class SaeIntegrations {

  constructor(private saeIntegrationsHttpService: SaeIntegrationsHttpService) { }

  async getSaes() {
    const source$ = this.saeIntegrationsHttpService.getSaes();
    const response = await lastValueFrom(source$);
    const saesArray = objectToCamel(response as []);
    return saesArray;
  }
}
